import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';


const StatusOverlay = ({ backdrop = false, children, fixed = false }) => (
  <div className={classnames('status-overlay', { fixed, backdrop })}>
    {children}
  </div>
);

StatusOverlay.propTypes = {
  backdrop: PropTypes.bool,
  children: PropTypes.any,
  fixed: PropTypes.bool,
};

export default StatusOverlay;
